// CreditCardPayment.jsx
import Cookies from 'js-cookie';

const handleCreditCardPayment = async (props, token) => {
  let url = process.env.REACT_APP_MODE !== null && process.env.REACT_APP_MODE !== undefined && process.env.REACT_APP_MODE.includes('dev') ? 'http://localhost:8080/edge' : '/edge';
  const jwt = Cookies.get('jwt-token');
  if (!jwt) {
    window.location.href = `/error-occurred`;
  }
  try {
    const urlParams = new URLSearchParams(window.location.search);
    const uuidFromUrl = urlParams.get('uuid');
    const id = props.inputValues.id || uuidFromUrl;

    const response = await fetch(`${url}/vero/payment/create`, {
      method: "POST",
      mode: "cors",
      headers: new Headers({
        "Content-Type": "application/json",
        "Authorization": `Bearer ${jwt}`
      }),
      body: JSON.stringify({
        cancelUrl: 'uuid=' + id,
        failureUrl: 'uuid=' + id,
        successUrl: 'uuid=' + id,
        supportedCardTypes: ['VISA', 'MASTER', 'AMEX'],
        enable3DS: true,
        "recaptchaResponse": token
      })
    });

    const json = await response.json();
    const paymentUrl = json.data.attributes.url;

    if (paymentUrl) {
      window.location.href = paymentUrl; // Redirect to the payment URL
    } else {
      console.log('URL not found in response');
    }
  } catch (error) {
    console.log('Error:', error);
  }
};

export default handleCreditCardPayment;
